import { en } from './en';
import { ru } from './ru';
import { ar } from './ar';
import { tr } from './tr';

export const translations = { en, ru, ar, tr };
